/** Inline message. tone: info | danger | success | warn. Errors are announced. */
export default function Alert({ tone = 'info', children, title }) {
  return (
    <div className={`alert alert-${tone}`} role={tone === 'danger' ? 'alert' : 'status'}>
      {title && <strong className="alert-title">{title}</strong>}
      {children}
    </div>
  );
}
